import { mediaResources } from "../Constants";


export const medias = {
    images: {
        
        header: {
            pagelogo: `${mediaResources}/Header/pagelogo.svg`,
            graduationCap: `${mediaResources}/Header/graduationCap.svg`,
            select: `${mediaResources}/Header/select.svg`
        },
        guidance: {
            GuidanceFace1: `${mediaResources}/Guidance/GuidanceFace1.svg`,
            Face1Icon: `${mediaResources}/Guidance/Face1Icon.svg`,
            unigole: `${mediaResources}/Guidance/unigole.png`,
            Face1TitleTopIcon: `${mediaResources}/Guidance/Face1TitleTopIcon.svg`,
            Face2: {
                CareerGuide1: `${mediaResources}/Guidance/CareerGuide1.svg`,
                CareerGuide2: `${mediaResources}/Guidance/CareerGuide2.svg`,
                CareerGuide3: `${mediaResources}/Guidance/CareerGuide3.svg`,
                CareerGuide4: `${mediaResources}/Guidance/CareerGuide4.svg`,
                CareerGuide5: `${mediaResources}/Guidance/CareerGuide5.svg`
            },
            Face3: {
                face3main: `${mediaResources}/Guidance/Face3.svg`
            },
            Face4: {
                face4Base: `${mediaResources}/Guidance/face4Base.png`,
                face4languageImages: `${mediaResources}/Guidance/face4languageImages.png`
            },
            Face5: {
                face5roadMap: `${mediaResources}/Guidance/face5roadMap.png`,
                Plan1: `${mediaResources}/Guidance/Plan1.svg`,
                Plan2: `${mediaResources}/Guidance/Plan2.svg`,
                Plan3: `${mediaResources}/Guidance/Plan3.svg`
            },
            Face6: {
                MetaMentor: `${mediaResources}/Guidance/MetaMentor.png`,
                metalogo: `${mediaResources}/Guidance/logo-Meta.png`,
                NetFlixMentor: `${mediaResources}/Guidance/NetFlixMentor.png`,
                netflixlogo: `${mediaResources}/Guidance/netflix-logo.png`
            },
            Face7: {
                Universities: `${mediaResources}/Guidance/Universities.png`,
                    Person1: `${mediaResources}/Guidance/Person1.png`,
                    Person2: `${mediaResources}/Guidance/Person2.png`,
                    Person3: `${mediaResources}/Guidance/Person3.png`,
                    Person4: `${mediaResources}/Guidance/Person4.png`,
                    Person5: `${mediaResources}/Guidance/Person5.png`,
                    Person6: `${mediaResources}/Guidance/Person6.png`,
                    Person7: `${mediaResources}/Guidance/Person7.png`,
                    Person8: `${mediaResources}/Guidance/Person8.png`,
                    Person9: `${mediaResources}/Guidance/Person9.png`,
                    Person10: `${mediaResources}/Guidance/Person10.png`
                },
            Face8 : {
                InvertedComa : `${mediaResources}/Guidance/InvertedComa.png`,
                Testimonial : `${mediaResources}/Guidance/Testimonial.png`,
                ThumbsUp : `${mediaResources}/Guidance/ThumbsUp.png`,
                pathBottom: `${mediaResources}/Guidance/pathBottom.png`,
                Person1Testimony: `${mediaResources}/Guidance/Person1Testimony.png`,
                Person2Testimony: `${mediaResources}/Guidance/Person2Testimony.png`,
            },
            Face9 : {
                UnerlineCurve2 : `${mediaResources}/Guidance/UnerlineCurve2.png`,
                bullet : `${mediaResources}/Guidance/bullet.png`,
                AppStore: `${mediaResources}/Guidance/AppStore.png`,
                GooglePlay: `${mediaResources}/Guidance/GooglePlay.png`,
                Mobiles: `${mediaResources}/Guidance/Mobiles.png`
                 
            },
            Face10: {
                LogoBetween : `${mediaResources}/Guidance/LogoBetween.png`,
                Perk1 : `${mediaResources}/Guidance/Perk1.png`,
                Perk2 : `${mediaResources}/Guidance/Perk2.png`,
                Perk3 : `${mediaResources}/Guidance/Perk3.png`,
                Perk4 : `${mediaResources}/Guidance/Perk4.png`,
                Perk5 : `${mediaResources}/Guidance/Perk5.png`,
                Perk6 : `${mediaResources}/Guidance/Perk6.png`,
            
            }

        },
        nineTenthPlan : {
            Face1 : {
                Face1Logo : `${mediaResources}/nineTenthPlan/Face1Logo.svg`,
                Face1MainImage : `${mediaResources}/nineTenthPlan/Face1MainImage.svg`,
                Face1Background : `${mediaResources}/nineTenthPlan/Face1Background.png`
            },
            Face3: {
                Face3mainImage : `${mediaResources}/nineTenthPlan/Face3mainImage.svg`
            },
            Face2: {
                Face3Card1 : `${mediaResources}/nineTenthPlan/Face3Card1.svg`,
                Face3Card2 : `${mediaResources}/nineTenthPlan/Face3Card2.svg`,
                Face3Card3 : `${mediaResources}/nineTenthPlan/Face3Card3.svg`
            },
            Face4 : {
                vsPanal : `${mediaResources}/nineTenthPlan/vsPanal.png`,
                divider : `${mediaResources}/nineTenthPlan/divider.png`
            },
            Face5 : {
                playicon : `${mediaResources}/nineTenthPlan/Playicon.png`
            }
            
        },
        footer : {
            appStore : `${mediaResources}/Guidance/app-store.png`,
            googlePlay : `${mediaResources}/Guidance/google-play.png`,
            facebook : `${mediaResources}/Guidance/facebook.svg`,
            instagram : `${mediaResources}/Guidance/instagram.svg`,
            linkedin : `${mediaResources}/Guidance/linkedin.svg`,
            youtube : `${mediaResources}/Guidance/youtube.svg`,
            FooterLogo : `${mediaResources}/Guidance/FooterLogo.svg`
        },
        loginSignup : {
            gridcircle : `${mediaResources}/LoginSignup/gridcircle.json`,
            LoginIcon1 : `${mediaResources}/LoginSignup/LoginIcon1.svg`,
            LoginIcon2 : `${mediaResources}/LoginSignup/LoginIcon2.svg`,
            LoginIcon3 : `${mediaResources}/LoginSignup/LoginIcon3.svg`,
            LoginIcon4 : `${mediaResources}/LoginSignup/LoginIcon4.svg`,
            LoginIcon5 : `${mediaResources}/LoginSignup/LoginIcon5.svg`,
            LoginIcon6 : `${mediaResources}/LoginSignup/LoginIcon6.svg`,
            LoginIcon7 : `${mediaResources}/LoginSignup/LoginIcon7.svg`,
            LoginIcon8 : `${mediaResources}/LoginSignup/LoginIcon8.svg`,
            LoginIcon9 : `${mediaResources}/LoginSignup/LoginIcon9.svg`,
            LoginIcon10 : `${mediaResources}/LoginSignup/LoginIcon10.svg`,
            
        },
        inputIcons : {
            EmailInputIcon : `${mediaResources}/InputIcons/EmailInputIcon.svg`,
            PasswordInputIcon : `${mediaResources}/InputIcons/PasswordInputIcon.svg`,
            FacebookLogo : `${mediaResources}/InputIcons/FacebookLogo.svg`,
            GoogleLogo : `${mediaResources}/InputIcons/GoogleLogo.svg`,
            firstNameIcon : `${mediaResources}/InputIcons/firstNameIcon.svg`, 
            cityIcon : `${mediaResources}/InputIcons/cityIcon.svg`, 
            stateIcon : `${mediaResources}/InputIcons/stateIcon.svg`, 
            lastNameIcon:  `${mediaResources}/InputIcons/lastNameIcon.svg`, 
            countryIcon: `${mediaResources}/InputIcons/countryIcon.svg`,

        },
        intrestImages : {
            globe:`${mediaResources}/IntrestQuestionair/globe.svg`,
            SelectorsDrops: `${mediaResources}/IntrestQuestionair/SelectorsDrops.svg`,
            volumeIcon :`${mediaResources}/IntrestQuestionair/volumeIcon.svg`,
            backmain :`${mediaResources}/IntrestQuestionair/backmain.svg`,
            coinIcon : `${mediaResources}/IntrestQuestionair/coinIcon.svg`,
            baseScreen : `${mediaResources}/IntrestQuestionair/baseScreen.webp`, 
            leftbgStone : `${mediaResources}/IntrestQuestionair/leftbgStone.png`,
            stonebottom :`${mediaResources}/IntrestQuestionair/stonebottom.png`,
            questionirebg : `${mediaResources}/IntrestQuestionair/questionirebg.svg`,
            borderBackground : `${mediaResources}/IntrestQuestionair/borderBackground.svg`, 
            timerBackgroung:`${mediaResources}/IntrestQuestionair/timerBackgroung.png`,
        },
        personalityImage : {
            timerbg : `${mediaResources}/PersonalityQuestion/timerbg.svg`
        },
        socialBehaviour : {
            timerbg : `${mediaResources}/SocialBehaviour/timerbg.svg`,
            leftmainbg : `${mediaResources}/SocialBehaviour/leftmainbg.svg`,
            bottommainbg : `${mediaResources}/SocialBehaviour/bottommainbg.svg`
        },
        aptitude : {
            timebg : `${mediaResources}/aptitude/timebg.png`
        },
        getStarted : {
            bottommain : `${mediaResources}/getstarted/bottomMain.png`
        },
        Home: {
            Menu : {
                Home : `${mediaResources}/HomeSection/MenuLayout/Home.svg`,
                MyCollection : `${mediaResources}/HomeSection/MenuLayout/MyCollections.svg`,
                MentorShip : `${mediaResources}/HomeSection/MenuLayout/MentorShip.svg`,
                Documents : `${mediaResources}/HomeSection/MenuLayout/Documents.svg`,
                CareerCounsellingSelected: `${mediaResources}/HomeSection/MenuLayout/CareerCounsellingSelected.svg`,
                bg: `${mediaResources}/HomeSection/MenuLayout/bg.png`, 
                OrderPurchases: `${mediaResources}/HomeSection/MenuLayout/OrderPurchases.svg`, 
                MyCollections: `${mediaResources}/HomeSection/MenuLayout/MyCollections.svg`, 
                MyCourses: `${mediaResources}/HomeSection/MenuLayout/MyCourses.svg`, 
                RewaredsBadges: `${mediaResources}/HomeSection/MenuLayout/RewaredsBadges.svg`,
            },
        },
        Profile : {
                LearningStyle:`${mediaResources}/Profile/CareerCounselling/LearningStyle.svg`,
                Aptitude:`${mediaResources}/Profile/CareerCounselling/Aptitude.svg`, 
                Intrest:`${mediaResources}/Profile/CareerCounselling/Intrest.svg`, 
                Personality:`${mediaResources}/Profile/CareerCounselling/Personality.svg`, 
                SocialBehaviour:`${mediaResources}/Profile/CareerCounselling/SocialBehaviour.svg`,
                Sessionschedule : `${mediaResources}/Profile/CareerCounselling/Sessionschedule.svg`, 
                Report : `${mediaResources}/Profile/CareerCounselling/Report.svg` ,
                Plans : `${mediaResources}/Profile/CareerCounselling/Plans.svg` ,
                psychometricTest : `${mediaResources}/Profile/CareerCounselling/psychometricTest.svg`, 
                Profilebuilding : `${mediaResources}/Profile/CareerCounselling/Profilebuilding.svg` ,
                CareerMapping : `${mediaResources}/Profile/CareerCounselling/CareerMapping.svg`,
                PersonalityDevelopment : `${mediaResources}/Profile/CareerCounselling/PersonalityDevelopment.svg`,
                TestNow : `${mediaResources}/Profile/CareerCounselling/TestNow.svg`
        },
        HomeMain : {
            ExploreMore : `${mediaResources}/Home/ExploreMore.png`,
            IITBhu : `${mediaResources}/Home/IITBhu.png` ,
            IIMDelhi : `${mediaResources}/Home/IIMDelhi.png`, 
            IITBom : `${mediaResources}/Home/IITBom.png` ,
            SSCC : `${mediaResources}/Home/SSCC.png` ,
            IITDelhi : `${mediaResources}/Home/IITDelhi.png`,
            FindCollege : {
                     Exams : `${mediaResources}/Home/Exams.png`, 
                     CollegeP : `${mediaResources}/Home/CollegeP.png`, 
                     Ranking : `${mediaResources}/Home/Ranking.png`, 
                     CourseFinder : `${mediaResources}/Home/CourseFinder.png`, 
                     CompareCollege : `${mediaResources}/Home/CompareCollege.png`, 
                     FindCollege : `${mediaResources}/Home/FindCollege.png`, 
                     Scholarship : `${mediaResources}/Home/Scholarship.png`, 
                     Careers : `${mediaResources}/Home/Careers.png`
            },
            states : {
                indiagate :`${mediaResources}/Home/indiagate.svg`, 
                hyderabadcharminar :`${mediaResources}/Home/hyderabadcharminar.svg`, 
                mumbai :`${mediaResources}/Home/mumbai.svg`, 
                chennai :`${mediaResources}/Home/chennai.svg`, 
                pune :`${mediaResources}/Home/pune.svg`, 
                bhopal :`${mediaResources}/Home/bhopal.svg`,  
            },
            DocVerified:`${mediaResources}/DocVerified.svg`, 
            ranking:`${mediaResources}/ranking.svg`,
            arrowHome : `${mediaResources}/Home/arrow.svg`,
            College : `${mediaResources}/Home/backgroundImage.png`, 
        },
        getStartedPopup : `${mediaResources}/getStartedPopup.svg`,
        instructionBanner:`${mediaResources}/instructionBanner.svg`,
        congratulations : {
            Intrest : `${mediaResources}/Congratulations/Intrest.svg`, 
            Aptitude : `${mediaResources}/Congratulations/Aptitude.svg`, 
            AptitudeCheck : `${mediaResources}/Congratulations/AptitudeCheck.svg`, 
            IntrestCheck : `${mediaResources}/Congratulations/IntrestCheck.svg`, 
            Personality : `${mediaResources}/Congratulations/Personality.svg`, 
            PersonalityCheck : `${mediaResources}/Congratulations/PersonalityCheck.svg`, 
            SocialBehaviour : `${mediaResources}/Congratulations/SocialBehaviour.svg`, 
            socialBehaviourCheck : `${mediaResources}/Congratulations/socialBehaviourCheck.svg`, 
            TextBanner : `${mediaResources}/Congratulations/TextBanner.png`,
        },
        profilemainLogo : `${mediaResources}/Profile/unigoal.png`
    }
}


